import { fetchJson } from '../fetchUtils';

export const fetchFullstoryConfig = async () => {
  const res = await fetchJson('/api/user/getFullstoryConfig');
  return res.fullstoryConfig;
};
